import { render, staticRenderFns } from "./CWordcloud.vue?vue&type=template&id=71acc90a&scoped=true&"
import script from "./CWordcloud.vue?vue&type=script&lang=js&"
export * from "./CWordcloud.vue?vue&type=script&lang=js&"
import style0 from "./CWordcloud.vue?vue&type=style&index=0&id=71acc90a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71acc90a",
  null
  
)

export default component.exports